import { useMutation, useQuery } from "@apollo/client";
import { BudgetType } from "../../../components/DealInformation/Budget/Config";
import {
  GetDealInfoBudgetDocument,
  GetDealInfoBudgetQuery,
  UpdateDealDataInfoDocument,
} from "../../../generated/graphql-operations";

export const useGetDealInfoBudget = (dealId: number) => {
  const dealInfoUnitInfo = useQuery(GetDealInfoBudgetDocument, {
    variables: {
      deal_id: dealId,
    },
  });

  return dealInfoUnitInfo;
};

export const transformBudget = (data: GetDealInfoBudgetQuery): BudgetType => {
  const dealData = data.Deals_by_pk?.DealData?.[0];

  return {
    budgetRent: dealData?.budget_rent ?? undefined,
    budgetOutgoings: dealData?.budget_outgoings ?? undefined,
    budgetPromotionLevy: dealData?.budget_promotion_levy ?? undefined,
    budgetIncentive: dealData?.budget_incentive ?? undefined,
    budgetLessorworks: dealData?.budget_lessorworks ?? undefined,
    budgetMakegood: dealData?.budget_makegood ?? undefined,
    budgetRentValuation: dealData?.budget_rent_valuation ?? undefined,
  };
};

export const useMutateDealBudget = (deal_id: number) => {
  // If refetching queries is too slow then we can manually update the cache using
  // https://www.apollographql.com/docs/react/data/mutations/#refetching-after-update
  // Or we can consider using subscriptions instead
  const [updateDateInfo] = useMutation(UpdateDealDataInfoDocument, {
    refetchQueries: [GetDealInfoBudgetDocument],
  });
  return async (data: BudgetType) => {
    await updateDateInfo({
      variables: {
        deal_id,
        update_object: {
          budget_rent: data.budgetRent ?? undefined,
          budget_outgoings: data.budgetOutgoings ?? undefined,
          budget_promotion_levy: data.budgetPromotionLevy ?? undefined,
          budget_incentive: data.budgetIncentive ?? undefined,
          budget_lessorworks: data.budgetLessorworks ?? undefined,
          budget_makegood: data.budgetMakegood ?? undefined,
          budget_rent_valuation: data.budgetRentValuation ?? undefined,
        },
      },
    });
  };
};
